import React, {useEffect, useState} from "react";
import {defaultTo, mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {DocumentsBatch, RefpadoDocument} from "../../types";
import {QRFooter} from "../qr_footer/QRFooter";
import {selectedDocument} from "./index";
import {DocTable} from "../../components/doc_table/DocTable";
import {RefdebtResponse} from "../../types/refdebt";
import {AvailableDocuments} from "./AvailableDocuments";

export const RefdebtDoc: React.FC<{ documents: DocumentsBatch , withVersions?: boolean }> = ({
                                                                                                 documents,
                                                                                                 withVersions = true
                                                                                             }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<RefdebtResponse>(
            selectedDocument.document.document as RefdebtResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as RefdebtResponse);
    }, [selectedDocument.document.version]);


    const title = `Справка о наличии/отсутствии задолженности/переплаты № ${mayBe(doc.refNumber) || 'б/н'}`;
    const subTitle = `Выдана заявителю:`;

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };


    return (
            <>

                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.oksInfo.lastName)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.oksInfo.firstName)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.oksInfo.midName)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.oksInfo.birthdate) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={getDocument(doc.oksInfo.document)}
                        />
                    </div>

                    <DocTitle title={''}
                              subtitle={'Зарегистрированному(-ой) по месту жительства по адресу:'}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Адрес регистрации" bold value={mayBe(doc.oksInfo.regAddress)}/>
                        <DocRow title="В том, что за жилым помещением, расположенным по адресу" bold
                                value={mayBe(doc.flsAddress)}/>
                        <DocRow title="Код плательщика" bold value={mayBe(doc.flsCode)}/>
                    </div>
                </div>
                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }
                <div className="col-span-12 md:col-span-8 md:order-last">
                    <DocTable
                            className={'doc-table--refdebt-services bottom-line'}
                            title={`Наименование услуги и сумма задолженности/переплаты по оплате жилого помещения и коммунальных услуг на ${doc.refDate} в разрезе услуг (руб.):`}
                            headers={[
                                'Услуга, по которой имеется задолженность/переплата',
                                'Размер задолженности/переплаты'
                            ]}
                            rows={doc.services.map(service => [service.name, service.value.toString()])}
                            empty={''}/>


                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.refDate}
                              mfcInfoName={doc.mfcInfo.name}
                              mfcUserName={doc.mfcUser.name}
                    />
                </div>
            </>
    );
};
